import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const listTeamMembersTE = <E = CF.API.ApiError>(
  { orgId, teamId, params = '' }: { orgId: string; teamId: string; params?: string },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Organizations.ListTeamMembersResponse> =>
  fetchTE<CF.API.Organizations.ListTeamMembersResponse, E>(
    {
      path: `/api/_api/v2/organizations/${orgId}/teams/${teamId}/users${params ? `?${params}` : ''}`,
      method: 'GET',
    },
    onRejected,
  );
